import CompoundHeader from "./CompoundHeader";
import { DesktopButtons } from "./DesktopButtons";
import { MobileButtons } from "./MobileButtons";

export { DesktopButtons } from "./DesktopButtons";
export { MobileButtons } from "./MobileButtons";

export const ResponsiveHeader = Object.assign(CompoundHeader, {
    Desktop: DesktopButtons,
    Mobile: MobileButtons,
});

export default ResponsiveHeader;
